module.exports = __webpack_public_path__ + "media/src/images/demoTop_number02-6e95572c329d1bc6319af7cacd7b0b63.png";